<div class="modal-header">
  <h2 class="modal-title" id="ks-user-modal-title">Editar usuario</h2>

  <button type="button" class="ks-modal-close" aria-label="Cerrar el modal" (click)="cancel()">
    <i class="bi bi-x-lg" aria-hidden="true"></i>
  </button>
</div>

<form [formGroup]="form" (ngSubmit)="submit()" novalidate>
  <div class="modal-body">
    <!-- Identidad: solo lectura, el API no actualiza email ni uid. -->
    <div class="ks-subpanel ks-user-modal__identity">
      <span class="ks-user-modal__avatar" aria-hidden="true">{{ initials() }}</span>

      <div class="ks-user-modal__identity-text">
        <p class="ks-user-modal__email">{{ user()?.email }}</p>
        <p class="ks-user-modal__uid">
          <span class="ks-muted">UID</span>
          <code>{{ user()?.uid }}</code>
        </p>
      </div>

      <span class="ks-user-modal__readonly-tag">
        <i class="bi bi-lock-fill" aria-hidden="true"></i>
        Solo lectura
      </span>
    </div>

    <div class="ks-grid ks-grid-2">
      <div class="ks-form-group">
        <label class="ks-label" for="ks-user-names">Nombre(s)</label>
        <input
          id="ks-user-names"
          type="text"
          class="ks-field"
          formControlName="names"
          autocomplete="given-name"
          maxlength="120"
          [attr.aria-invalid]="invalid('names')"
          [attr.aria-describedby]="invalid('names') ? 'ks-user-names-error' : null"
        />

        @if (invalid('names')) {
          <p class="ks-field-error" id="ks-user-names-error">
            <i class="bi bi-exclamation-circle-fill" aria-hidden="true"></i>
            El nombre es obligatorio.
          </p>
        }
      </div>

      <div class="ks-form-group">
        <label class="ks-label" for="ks-user-last-names">Apellidos</label>
        <input
          id="ks-user-last-names"
          type="text"
          class="ks-field"
          formControlName="lastNames"
          autocomplete="family-name"
          maxlength="120"
          [attr.aria-invalid]="invalid('lastNames')"
          [attr.aria-describedby]="invalid('lastNames') ? 'ks-user-last-names-error' : null"
        />

        @if (invalid('lastNames')) {
          <p class="ks-field-error" id="ks-user-last-names-error">
            <i class="bi bi-exclamation-circle-fill" aria-hidden="true"></i>
            Los apellidos son obligatorios.
          </p>
        }
      </div>
    </div>

    <div class="ks-form-group">
      <label class="ks-label" for="ks-user-profile">Perfil</label>

      <!--
        ng-select, no <select>: todos los selects de la consola deben poder
        BUSCAR. `[clearable]="false"` porque el perfil no admite un valor en
        blanco (el <select> nativo tampoco tenia una opcion vacia).
      -->
      <ng-select
        labelForId="ks-user-profile"
        formControlName="profile"
        [items]="profileOptions()"
        bindLabel="label"
        bindValue="profile"
        placeholder="Selecciona un perfil"
        notFoundText="Sin resultados"
        clearAllText="Quitar selección"
        loadingText="Cargando perfiles…"
        typeToSearchText="Escribe para buscar"
        [searchable]="true"
        [clearable]="false"
        [inputAttrs]="profileInputAttrs()"
        [class.is-invalid]="invalid('profile')" />

      @if (invalid('profile')) {
        <p class="ks-field-error" id="ks-user-profile-desc" role="alert">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          Elige el perfil del usuario.
        </p>
      } @else {
        <p class="ks-field-hint" id="ks-user-profile-desc">
          Solo se listan los perfiles activos del catálogo.
        </p>
      }
    </div>

    @if (isSudoSelected()) {
      <div
        class="ks-user-modal__warning"
        [class.ks-user-modal__warning--escalation]="isSudoEscalation()"
        role="alert"
      >
        <i class="bi bi-shield-exclamation" aria-hidden="true"></i>

        <div>
          <p class="ks-user-modal__warning-title">
            {{ isSudoEscalation() ? 'Estás por otorgar acceso total' : 'Este usuario es sudo' }}
          </p>
          <p class="ks-user-modal__warning-text">
            El perfil <strong>sudo</strong> da acceso completo a la consola administrativa: gestión
            de usuarios, cierre de sesiones y edición de catálogos.
            @if (isSudoEscalation()) {
              Se te pedirá confirmar el cambio antes de guardar.
            }
          </p>
        </div>
      </div>
    }

    <div class="ks-form-group">
      <span class="ks-label" id="ks-user-status-label">Estado</span>

      <label class="ks-switch" for="ks-user-status">
        <input
          id="ks-user-status"
          type="checkbox"
          role="switch"
          class="ks-switch__input"
          formControlName="status"
          aria-labelledby="ks-user-status-label"
          aria-describedby="ks-user-status-hint"
        />

        <span class="ks-switch__track" aria-hidden="true">
          <span class="ks-switch__thumb"></span>
        </span>

        <span class="ks-switch__text">
          <span class="ks-switch__title">
            {{ form.controls.status.value ? 'Activo' : 'Inactivo' }}
          </span>
        </span>
      </label>

      <p class="ks-field-hint" id="ks-user-status-hint">
        Un usuario inactivo no puede iniciar sesión en la app móvil.
      </p>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="ks-btn ks-btn--glass" (click)="cancel()">Cancelar</button>

    <button type="submit" class="ks-btn ks-btn--primary" [disabled]="submitting()">
      <i class="bi bi-check-lg" aria-hidden="true"></i>
      Guardar cambios
    </button>
  </div>
</form>
